import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";

const MoneyReturnedToBankModal = ({
  changeMoneyReturnToBank,
  closeMoneyReturnedToBankModal,
}) => {
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeMoneyReturnedToBankModal);
  }, [closeMoneyReturnedToBankModal]);
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="money-returned-to-bank-modal-content" ref={ref}>
        <div className="modal-header" style={{ height: "100px" }}>
          <button className="close" onClick={closeMoneyReturnedToBankModal}>
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title" id="myModalLabel2">
            Would you like to proceed?
          </h4>
        </div>
        <div className="modal-footer">
          <button
            className="btn rc-btn_primary pad-L20 pad-R20"
            onClick={(e) => {
              changeMoneyReturnToBank(true);
              closeMoneyReturnedToBankModal();
              e.stopPropagation();
            }}
          >
            Yes
          </button>
          <button
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeMoneyReturnedToBankModal}
          >
            No
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default MoneyReturnedToBankModal;
